import { gql } from '__generated__';

export default gql(`
  mutation SaveInterest($input: SaveInterestInput!) {
    saveInterest(input: $input)
  }
`);
